// eslint-disable-next-line no-unused-vars
import request from '@/service/http'

// 一览
export function searchList (data) {
  return request({
    url: '/api/abandon/searchList',
    method: 'post',
    data,
  })
}
// 全部删除
export function deleteFile (data) {
  return request({
    url: '/api/abandon/deleteFile',
    method: 'get',
    data,
  })
}
// 单个删除
export function deleteOneFile (id) {
  return request({
    url: '/api/abandon/deleteOneFile',
    method: 'get',
    params: {id},
  })
}
// 废弃文件扫描
export function fileScan (data) {
  return request({
    url: '/api/abandon/fileScan',
    method: 'post',
    data,
  })
}